import { Reducer } from 'redux';
import { isNullOrUndefinedOrEmptyString } from '../../Utils/Various';
import {
	IAppsManagementActionTypes,
	IAppsManagementState,
	Media,
} from './Types';

const initialState: IAppsManagementState = {
	allMedias: [],
	channelGroups: [],
	channelUsers: [],
	errorAllMedias: '',
	errorChannelGroupsAndUser: '',
	errorSelectedMedia: '',
	errorUserChannels: '',
	loadingMedias: true,
	loadingChannelGroupsAndUser: true,
	loadingUserChannels: true,
	selectedMedia: null,
	userChannels: [],
	allChannelsFilter: null,
	loading: false,
	error: null
};

const reducer: Reducer<IAppsManagementState> = (
	state = initialState,
	action
) => {
	switch (action.type) {
		case IAppsManagementActionTypes.RESET_MEDIAS: {
			return initialState;
		}
		case IAppsManagementActionTypes.GET_ALL_MEDIAS_FAILED: {
			return {
				...state,
				allMedias: [],
				loadingMedias: false,
				errorAllMedias: action.payload,
			};
		}
		case IAppsManagementActionTypes.GET_ALL_MEDIAS_SUCCEED: {
			let array: Media[] = action.payload;

			array = array.map((value: Media) => {
				let newfirst = value.firstChunk * 1000;
				let newlast = value.lastChunk * 1000;

				let newStart = '';
				let newEnd = '';

				if (!isNullOrUndefinedOrEmptyString(value.start)) {
					const start = value.start.split(' ');
					const startDebut = start[0].split('/');
					newStart =
						startDebut[2] +
						'-' +
						startDebut[1] +
						'-' +
						startDebut[0] +
						'T' +
						start[1];
				} else {
					newStart = '0000-00-00T00:00:00';
				}
				if (!isNullOrUndefinedOrEmptyString(value.end)) {
					const start = value.end.split(' ');
					const startDebut = start[0].split('/');
					newEnd =
						startDebut[2] +
						'-' +
						startDebut[1] +
						'-' +
						startDebut[0] +
						'T' +
						start[1];
				} else {
					newEnd = '';
				}

				return {
					encoding: value.encoding,
					firstChunk: newfirst,
					id: value.id,
					lastChunk: newlast,
					mediaSource: value.mediaSource,
					type: value.type,
					name: value.name,
					start: newStart,
					end: newEnd,
				};
			});

			return {
				...state,
				allMedias: array,
				loadingMedias: false,
				errorAllMedias: '',
			};
		}
		case IAppsManagementActionTypes.GET_CHANNELS_FROM_USER_FAILED: {
			return {
				...state,
				errorUserChannels: action.payload,
				loadingUserChannels: false,
				userChannels: [],
			};
		}
		case IAppsManagementActionTypes.GET_CHANNELS_FROM_USER_SUCCEED: {
			return {
				...state,
				errorUserChannels: '',
				loadingUserChannels: false,
				userChannels: action.payload,
				loading: false
			};
		}
		case IAppsManagementActionTypes.GET_CHANNELS_FROM_USER_MT_FAILED: {
			return {
				...state,
				errorUserChannels: action.payload,
				loadingUserChannels: false,
				userChannels: [],
			};
		}
		case IAppsManagementActionTypes.GET_CHANNELS_FROM_USER_MT_SUCCEED: {
			let array: Media[] = action.payload;

			array = array.map((value: Media) => {
				let newfirst = value.firstChunk * 1000;
				let newlast = value.lastChunk * 1000;

				let newStart = '';
				let newEnd = '';

				if (!isNullOrUndefinedOrEmptyString(value.start)) {
					const start = value.start.split(' ');
					const startDebut = start[0].split('/');
					newStart =
						startDebut[2] +
						'-' +
						startDebut[1] +
						'-' +
						startDebut[0] +
						'T' +
						start[1];
				} else {
					newStart = '0000-00-00T00:00:00';
				}
				if (!isNullOrUndefinedOrEmptyString(value.end)) {
					const start = value.end.split(' ');
					const startDebut = start[0].split('/');
					newEnd =
						startDebut[2] +
						'-' +
						startDebut[1] +
						'-' +
						startDebut[0] +
						'T' +
						start[1];
				} else {
					newEnd = '';
				}

				return {
					encoding: value.encoding,
					firstChunk: newfirst,
					id: value.id,
					lastChunk: newlast,
					mediaSource: value.mediaSource,
					type: value.type,
					name: value.name,
					start: newStart,
					end: newEnd,
				};
			});

			return {
				...state,
				errorUserChannels: '',
				loadingUserChannels: false,
				userChannels: array,
			};
		}
		case IAppsManagementActionTypes.GET_CHANNELS_FROM_USER_STT_FAILED: {
			return {
				...state,
				errorUserChannels: action.payload,
				loadingUserChannels: false,
				userChannels: [],
			};
		}
		case IAppsManagementActionTypes.GET_CHANNELS_FROM_USER_STT_SUCCEED: {
			return {
				...state,
				errorUserChannels: '',
				loadingUserChannels: false,
				userChannels: action.payload,
			};
		}
		case IAppsManagementActionTypes.GET_CHANNELS_FROM_USER_TPP_FAILED: {
			return {
				...state,
				errorUserChannels: action.payload,
				loadingUserChannels: false,
				userChannels: [],
			};
		}
		case IAppsManagementActionTypes.GET_CHANNELS_FROM_USER_TPP_SUCCEED: {
			return {
				...state,
				errorUserChannels: '',
				loadingUserChannels: false,
				userChannels: action.payload,
			};
		}
		case IAppsManagementActionTypes.GET_MEDIA_FAILED: {
			return {
				...state,
				errorSelectedMedia: action.payload,
				selectedMedia: null,
			};
		}
		case IAppsManagementActionTypes.GET_MEDIA_SUCCEED: {
			return {
				...state,
				errorSelectedMedia: '',
				selectedMedia: action.payload,
			};
		}
		case IAppsManagementActionTypes.GET_GROUPS_AND_USERS_FROM_CHANNEL_FAILED: {
			return {
				...state,
				channelGroups: [],
				channelUsers: [],
				errorChannelGroupsAndUser: action.payload,
				loadingChannelGroupsAndUser: false,
			};
		}
		case IAppsManagementActionTypes.GET_GROUPS_AND_USERS_FROM_CHANNEL_SUCCEED: {
			return {
				...state,
				channelGroups: action.payload[1],
				channelUsers: action.payload[0],
				errorChannelGroupsAndUser: '',
				loadingChannelGroupsAndUser: false,
			};
		}
		case IAppsManagementActionTypes.GET_GROUPS_FROM_CHANNEL_MT_FAILED: {
			return {
				...state,
				channelGroups: [],
				channelUsers: [],
				errorChannelGroupsAndUser: action.payload,
				loadingChannelGroupsAndUser: false,
			};
		}
		case IAppsManagementActionTypes.GET_GROUPS_FROM_CHANNEL_MT_SUCCEED: {
			return {
				...state,
				channelGroups: action.payload[1],
				channelUsers: action.payload[0],
				errorChannelGroupsAndUser: '',
				loadingChannelGroupsAndUser: false,
			};
		}
		case IAppsManagementActionTypes.GET_GROUPS_AND_USERS_FROM_CHANNEL_STT_FAILED: {
			return {
				...state,
				channelGroups: [],
				channelUsers: [],
				errorChannelGroupsAndUser: action.payload,
				loadingChannelGroupsAndUser: false,
			};
		}
		case IAppsManagementActionTypes.GET_GROUPS_AND_USERS_FROM_CHANNEL_STT_SUCCEED: {
			return {
				...state,
				channelGroups: action.payload[1],
				channelUsers: action.payload[0],
				errorChannelGroupsAndUser: '',
				loadingChannelGroupsAndUser: false,
			};
		}
		case IAppsManagementActionTypes.GET_GROUPS_AND_USERS_FROM_CHANNEL_TPP_FAILED: {
			return {
				...state,
				channelGroups: [],
				channelUsers: [],
				errorChannelGroupsAndUser: action.payload,
				loadingChannelGroupsAndUser: false,
			};
		}
		case IAppsManagementActionTypes.GET_GROUPS_AND_USERS_FROM_CHANNEL_TPP_SUCCEED: {
			return {
				...state,
				channelGroups: action.payload[1],
				channelUsers: action.payload[0],
				errorChannelGroupsAndUser: '',
				loadingChannelGroupsAndUser: false,
			};
		}
		case IAppsManagementActionTypes.SET_ALL_CHANNELS_FILTER: {
			return {
				...state,
				allChannelsFilter: action.payload,
			};
		}
		case IAppsManagementActionTypes.SET_LOADING_CHANNELS_FROM_USER: {
			return {
				...state,
				loadingUserChannels: action.payload,
			};
		}
		case IAppsManagementActionTypes.SET_LOADING_GROUPS_AND_USERS_FROM_CHANNEL: {
			return {
				...state,
				loadingChannelGroupsAndUser: action.payload,
			};
		}
		case IAppsManagementActionTypes.SET_LOADING_MEDIAS: {
			return {
				...state,
				loadingMedias: action.payload,
			};
		}
		case IAppsManagementActionTypes.SET_USER_CHANNELS:
		case IAppsManagementActionTypes.SET_USER_CHANNELS_STT:
		case IAppsManagementActionTypes.SET_USER_CHANNELS_TPP:
			return {
				...state,
				loading: true,
				error: null
			};

		case IAppsManagementActionTypes.SET_USER_CHANNELS_SUCCEED:
		case IAppsManagementActionTypes.SET_USER_CHANNELS_STT_SUCCEED:
		case IAppsManagementActionTypes.SET_USER_CHANNELS_TPP_SUCCEED:
			return {
				...state,
				loading: false,
				error: null
			};

		case IAppsManagementActionTypes.SET_USER_CHANNELS_FAILED:
		case IAppsManagementActionTypes.SET_USER_CHANNELS_STT_FAILED:
		case IAppsManagementActionTypes.SET_USER_CHANNELS_TPP_FAILED:
			return {
				...state,
				loading: false,
				error: action.payload
			};

		case IAppsManagementActionTypes.SET_GROUP_CHANNELS:
		case IAppsManagementActionTypes.SET_GROUP_CHANNELS_STT:
		case IAppsManagementActionTypes.SET_GROUP_CHANNELS_TPP:
			return {
				...state,
				loading: true,
				error: null
			};
		default: {
			return state;
		}
	}
};

export { reducer as AppsManagementReducer };
